import React, { useEffect, useState } from "react";
import { callingCode } from "../../../../helpers/helper";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getBookingStatus,
  resetTransferBooked,
  transferBookAsync,
  transferReturnBookAsync,
} from "../../../../features/bookings/transferSlice";
import SuccessModal from "../../../modals/SuccessModal";
import { useForm } from "../../../../hooks/useForm";

const TravellerDetail = () => {
  const Departure = JSON.parse(sessionStorage.getItem("departure"));
  const returnVal = JSON.parse(sessionStorage.getItem("return"));

  const customValidate = (errors) => {
    if (errors.AirlineCode === undefined && state.AirlineCode.length !== 3) {
      errors.AirlineCode = "Airline Code Must be Exact 3 Characters!";
    }

    if (
      errors.ZipCode === undefined &&
      (state.ZipCode.length < 5 || state.ZipCode.length > 7)
    ) {
      errors.ZipCode = "Zip Code Must be 5-7 Characters!";
    }
  };

  const {
    state,
    setState,
    isSubmit,
    formErrors,
    // handleInputChange,
    handleFormSubmit,
    checkErrors,
  } = useForm({
    val: {
      Title: "",
      FirstName: "",
      LastName: "",
      MobileNo: "",
      Email: "",
      CountryCode: "",
      AirlineCode: "",
      HotelAddress: "",
      ZipCode: "",
    },
    // dyncVals: {
    //   items: customers,
    //   setItems: setCustomers,
    //   arrItems: ["Title", "FirstName", "LastName"],
    // },
    inValidate: customValidate,
  });

  // const [isSubmit, setIsSubmit] = useState(false);
  // const [formErrors, setFormErrors] = useState({});

  const [pickUpDesp, setPickupDesp] = useState("");
  const [dropDesp, setdropDesp] = useState("");

  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");
  const [statusCode, setStatusCode] = useState("");

  const [show, setShow] = useState(false);
  const signatureData = JSON.parse(sessionStorage.getItem("signatureData"));
  const { Authorization } = JSON.parse(sessionStorage.getItem("userData"));
  const JourneyDetails = JSON.parse(sessionStorage.getItem("departure"));

  const dispatch = useDispatch();
  const bookingStatus = useSelector(
    (state) => state.transfer.bookingStatus,
    shallowEqual
  );
  const message = useSelector((state) => state.transfer.message, shallowEqual);
  const statusCodes = useSelector(
    (state) => state.transfer.status,
    shallowEqual
  );

  useEffect(() => {
    let formDetail = JSON.parse(sessionStorage.getItem("departure"));

    setPickupDesp(formDetail.PickUp.LocationType);
    setdropDesp(formDetail.DropOff.LocationType);
    dispatch(resetTransferBooked());
  }, []);

  useEffect(() => {
    if (bookingStatus === false) {
      setMsg(message);
      setShow(true);
      setStatusCode(statusCodes);
    }

    if (Object?.keys(bookingStatus).length > 0) {
      if (bookingStatus?.IsSuccess) {
        setStatusCode(statusCodes);
        setMsg(
          "Your booking has been Confirmed. Check your emails for details."
        );
        // setStatus("Awesome!");
      } else {
        setMsg(message);
        // setStatus("Failed!");
      }
      setShow(true);
    }
  }, [bookingStatus]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let TrackingId = JSON.parse(sessionStorage.getItem("trackingId"));
      let BookingData = JSON.parse(sessionStorage.getItem("transferSelected"));

      if (JSON.parse(sessionStorage.getItem("roundTrip")) === true) {
        let returnData = JSON.parse(sessionStorage.getItem("returnSelected"));

        returnData !== null &&
          dispatch(
            transferReturnBookAsync({
              state,
              TrackingId,
              BookingData,
              returnData,
              Authorization,
              signatureData,
              pickUpDesp,
              travelData: {
                booking_date: Departure?.TransferDate,
                booking_time: Departure?.TransferTime,
                return_date: returnVal?.TransferDate,
                return_time: returnVal?.TransferTime,
                from_place: Departure?.PickUp?.locationName,
                to_place: Departure?.DropOff?.locationName,
                total_traveller: Departure?.tcount,
              },
            })
          );
      } else {
        dispatch(
          transferBookAsync({
            state,
            TrackingId,
            BookingData,
            signatureData,
            Authorization,
            pickUpDesp,
            travelData: {
              booking_time: Departure?.TransferTime,
              booking_date: Departure?.TransferDate,
              return_date: null,
              return_time: null,
              from_place: Departure?.PickUp?.locationName,
              to_place: Departure?.DropOff?.locationName,
              total_traveller: Departure?.tcount,
            },
          })
        );
      }
    }
  }, [formErrors, isSubmit]);

  const handleInputChange = (e) => {
    e.target.name === "AirlineCode"
      ? setState({ ...state, [e.target.name]: e.target.value.toUpperCase() })
      : setState({ ...state, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="transfer-inner-wrap shadow-none p-0">
        <h4 className="title">Travellers Details</h4>
        <div className="transfer-wrap border-0">
          <div className="transfer-inner">
            <div className="row">
              <div className="col-lg-12">
                <ul className="transfer-lists m-0 border-0 guest-details-wrapper">
                  <form className="guest-detail-form guest-detail-form-input traveller">
                    <div>
                      <div
                        className="name-detail shadow-none p-0"
                        style={{ flexWrap: "wrap" }}
                      >
                        <div className="row">
                          <div className="col-lg-2">
                            <div className="form-group position-relative">
                              <div className="select-arrow"></div>
                              <label htmlFor="">Title</label>
                              <select
                                name="Title"
                                id="title"
                                autoComplete="off"
                                onChange={handleInputChange}
                              >
                                <option value="">Title</option>
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="Mrs">Mrs</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-5">
                            <div className="form-group ">
                              <label htmlFor="">First Name</label>
                              <input
                                type="text"
                                placeholder="Enter First Name"
                                name="FirstName"
                                value={state.FirstName}
                                onChange={handleInputChange}
                                // onFocus={(e) => setErrors(e)}
                                onBlur={(e) => checkErrors(e)}
                                autoComplete="off"
                              />
                              <span className="error">
                                {formErrors?.FirstName}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-5">
                            <div className="form-group my-2 ">
                              <label htmlFor="">Last Name</label>
                              <input
                                type="text"
                                placeholder="Enter Last Name"
                                name="LastName"
                                value={state.LastName}
                                onChange={handleInputChange}
                                // onFocus={(e) => setErrors(e)}
                                onBlur={(e) => checkErrors(e)}
                                autoComplete="off"
                              />
                              <span className="error">
                                {formErrors?.LastName}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group ">
                              <label htmlFor="">Email Address</label>
                              <input
                                type="email"
                                name="Email"
                                placeholder="Enter Email Address"
                                value={state.value}
                                onChange={handleInputChange}
                                // onFocus={(e) => setErrors(e)}
                                onBlur={(e) => checkErrors(e)}
                                autoComplete="off"
                              />
                              <span className="error">{formErrors?.Email}</span>
                            </div>
                          </div>

                          {/*

                          <div className="col-lg-6">
                            <div className="form-group mobile-number-wrap">
                              <label htmlFor="">Country Code</label>
                              <div className="d-flex">
                                <div className="d-block">
                                  <select
                                    name="CountryCode"
                                    className="form-control"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    // onFocus={(e) => setErrors(e)}
                                    onBlur={(e) => checkErrors(e)}
                                  >
                                    <option value="">
                                      Select Country code
                                    </option>
                                    {callingCode.map((ele, ind) => (
                                      <option key={ind} value={ele.value}>
                                        {ele.label}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="error">
                                    {formErrors?.CountryCode}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group ">
                              <label
                                htmlFor=""
                                // className="mb-0 mobile-number-2-fild"
                              >
                                Mobile Number
                              </label>
                              <input
                                type="Number"
                                placeholder="Enter Phone Number"
                                name="MobileNo"
                                value={state.MobileNo}
                                onChange={handleInputChange}
                                // onFocus={(e) => setErrors(e)}
                                onBlur={(e) => checkErrors(e)}
                                autoComplete="off"
                              />
                              <span className="error">
                                {formErrors?.MobileNo}
                              </span>
                            </div>
                          </div>
                        */}

                          <div className="col-lg-6">
                            <div className="mobile-number">
                              <div className="form-group">
                                <label for="">Mobile Number </label>
                                <div>
                                  <div className="position-relative select-country-code">
                                    <div className="select-arrow"></div>
                                    <select
                                      name="CountryCode"
                                      onChange={handleInputChange}
                                      className="form-control"
                                      onBlur={(e) => checkErrors(e)}
                                    >
                                      <option value=""> Code</option>
                                      {callingCode.map((ele, ind) => (
                                        <option
                                          key={ind}
                                          value={ele.label.split(" ")[0]}
                                        >
                                          {ele.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Enter Mobile Number"
                                    name="MobileNo"
                                    value={state.MobileNo}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                    onBlur={(e) => checkErrors(e)}
                                  />
                                </div>
                                <span className="error">
                                  {formErrors?.CountryCode}
                                </span>
                                <span className="error">
                                  {formErrors?.MobileNo}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div>
                              <h6 className="mt-md-4 mt-sm-4 add-pickup-txt">
                                {pickUpDesp === "TransferAirportDetail"
                                  ? "Add Airline code"
                                  : "Add Hotel Address"}
                              </h6>
                              <div className="pickup-address p-0 shadow-none">
                                <h5>
                                  {" "}
                                  {JourneyDetails["PickUp"]["locationName"]}
                                </h5>
                                {pickUpDesp === "TransferAirportDetail" ? (
                                  <>
                                    <div className="form-group">
                                      <input
                                        type="text"
                                        placeholder="Enter Airline Code"
                                        name="AirlineCode"
                                        value={state.AirlineCode}
                                        onChange={handleInputChange}
                                        // onFocus={(e) => setErrors(e)}
                                        onBlur={(e) => checkErrors(e)}
                                        autoComplete="off"
                                      />
                                    </div>
                                    <span className="error">
                                      {formErrors?.AirlineCode}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <div className="form-group">
                                      <input
                                        type="text"
                                        placeholder="Enter Hotel Address"
                                        name="HotelAddress"
                                        value={state.HotelAddress}
                                        onChange={handleInputChange}
                                        // onFocus={(e) => setErrors(e)}
                                        onBlur={(e) => checkErrors(e)}
                                        autoComplete="off"
                                      />
                                    </div>
                                    <span className="error">
                                      {formErrors?.HotelAddress}
                                    </span>

                                    <div className="form-group">
                                      <input
                                        type="Number"
                                        placeholder="Enter Zipcode"
                                        name="ZipCode"
                                        value={state.ZipCode}
                                        onChange={handleInputChange}
                                        // onFocus={(e) => setErrors(e)}
                                        onBlur={(e) => checkErrors(e)}
                                        autoComplete="off"
                                      />
                                    </div>
                                    <span className="error">
                                      {formErrors?.ZipCode}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>

                          <div>
                            <h6>
                              {dropDesp === "TransferAirportDetail"
                                ? "Add Airline code"
                                : "Add Hotel Address"}
                            </h6>
                            <div className="drop-off-address p-0 shadow-none">
                              <h5>
                                {JourneyDetails["DropOff"]["locationName"]}
                              </h5>
                              {dropDesp === "TransferAirportDetail" ? (
                                <>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      placeholder="Enter Airline Code"
                                      name="AirlineCode"
                                      value={state.AirlineCode}
                                      onChange={handleInputChange}
                                      // onFocus={(e) => setErrors(e)}
                                      onBlur={(e) => checkErrors(e)}
                                      autoComplete="off"
                                    />
                                  </div>
                                  <span className="error">
                                    {formErrors?.AirlineCode}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <div className="form-group">
                                    <label> Address </label>
                                    <input
                                      type="text"
                                      placeholder="Enter Hotel Address"
                                      name="HotelAddress"
                                      value={state.HotelAddress}
                                      onChange={handleInputChange}
                                      // onFocus={(e) => setErrors(e)}
                                      onBlur={(e) => checkErrors(e)}
                                      autoComplete="off"
                                    />
                                  </div>
                                  <span className="error">
                                    {formErrors?.HotelAddress}
                                  </span>

                                  <div className="form-group">
                                    <label> Zip Code </label>
                                    <input
                                      type="Number"
                                      placeholder="Enter Zipcode"
                                      name="ZipCode"
                                      value={state.ZipCode}
                                      onChange={handleInputChange}
                                      // onFocus={(e) => setErrors(e)}
                                      onBlur={(e) => checkErrors(e)}
                                      autoComplete="off"
                                    />
                                  </div>
                                  <span className="error">
                                    {formErrors?.ZipCode}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mt-0">
                      <input
                        className="cmn-btn form-btn mt-0"
                        // onClick={(e) => {
                        //   checkManualValidation(e);
                        // }}
                        onClick={handleFormSubmit}
                        type="button"
                        value="Book Transfer & Pay"
                      />
                    </div>

                    {/*  */}
                  </form>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  */}
      {show ? (
        <SuccessModal
          setShow={setShow}
          show={show}
          msg={msg}
          status={status}
          statusCode={statusCode}
        />
      ) : null}
    </>
  );
};

export default TravellerDetail;
